<template>
  <component
    v-if="props.href"
    :is="props.external ? 'a' : Link"
    :href="props.href"
    :target="props.external ? '_blank' : null"
    :class="[menuTextClasses]"
    prefetch
    >{{ props.name }}</component
  >

  <Popover v-else class="relative">
    <PopoverButton
      class="flex items-center gap-x-1 focus:outline-none"
      :class="[menuTextClasses]"
    >
      {{ props.name }}
      <ChevronDownIcon
        class="h-5 w-5 flex-none"
        :class="[props.arrowColor]"
        aria-hidden="true"
      />
    </PopoverButton>

    <transition
      enter-active-class="transition ease-out duration-200"
      enter-from-class="opacity-0 translate-y-1"
      enter-to-class="opacity-100 translate-y-0"
      leave-active-class="transition ease-in duration-150"
      leave-from-class="opacity-100 translate-y-0"
      leave-to-class="opacity-0 translate-y-1"
    >
      <MenuItemPanel :items="props.items" />
    </transition>
  </Popover>
</template>

<script setup>
import Link from '@/Common/util/inertia/Link.vue'
import { Popover, PopoverButton } from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/20/solid'
import { computed } from 'vue'
import MenuItemPanel from './MenuItemPanel.vue'

const props = defineProps({
  name: String,
  items: Array,
  textColor: String,
  arrowColor: String,
  href: String,
  external: Boolean,
})

const menuTextClasses = computed(
  () => `text-sm font-semibold leading-6 ${props.textColor}`
)
</script>
